import React, { Component } from "react";

import "./Footer.scss"
import yitLogoSrc from "../../static/images/yit.png"
import data from "../../api/data.json"

class Footer extends Component {
  constructor() {
    super();
    this.state = {
      yitLogo: {
        backgroundImage: "url(" + yitLogoSrc + ")"
      }
    }
  }
  goToIsracard()  {
    window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'Isracard',
        'Action': 'ContactUs_Clicked'
    });
  }
  render() {
    window.addEventListener("scroll", function () {
      if (window.scrollY >= 576 && window.location.href.indexOf("article") < 0) {
        window.document.querySelector(".stickyside").classList.add("minisize");
      } else {
        window.document.querySelector(".stickyside").classList.remove("minisize");
      }
    });
    return (
      <footer>
        <div id="footer">
          <div className="footerright">
            צילומי אילוסטרציה: iStockPhoto
          </div>
          <div className="padding">
            <a href="//www.yit.co.il/" title="YIT" target="_blank" rel="noopener noreferrer">
              <div className="credit">אפיון, עיצוב ופיתוח</div><div className="yitlogo" style={this.state.yitLogo}></div>
            </a>
          </div>
        </div>
        <div className="stickyside" onClick={this.goToIsracard}>
          <a href={data.footer.contact.link} title="" target="_blank">
            <div className="sticky"></div>
          </a>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js